<template lang="html">
    <div class="container">
        <div class="row">
            <div class="col s-10">

                <img class="center responsive-img" src="@/assets/images/hmy_claim.png"/>
            </div>
        </div>

        <div class="row">
            <div class="col s12 m10 center">
                <div class="card horizontal">
                    <div class="card-stacked">
                        <div class="card-content">
                            <p class="idea">Prendre une photo</p>
                            <p class="grey-text">Partagez-nous une photo de l'élément à améliorer.</p>
                        </div>
                        <router-link :to="{ name: 'LiveImprovement' }"  class="btn-floating btn-large halfway-fab waves-effect waves-light light-blue"><i class="material-icons">camera_alt</i></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 m10 center">
                <div class="card horizontal">
                    <div class="card-stacked">
                        <div class="card-content">
                            <p class="idea">Ou depuis votre galerie</p>
                            <p class="grey-text">Téléchargez un fichier depuis la galerie de votre appareil</p>
                        </div>
                        <router-link :to="{ name: 'GalleryImprovement' }"  class="btn-floating btn-large halfway-fab waves-effect waves-light light-blue"><i class="material-icons">create_new_folder</i></router-link>
                    </div>
                </div>
            </div>
        </div>



        <div class="row">
            <div class="col 12"><a href="mailto:amélioration.montage@hmy-group.com" class="center waves-effect waves-light btn-large light-blue"><i class="material-icons left">mail_outline</i>CONTACT AMELIORATION CONTINUE</a></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Media',
    data(){
        return{

        }
    }
}
</script>

<style lang="css" scoped>
.idea{
    font-size: 1.3em;
    font-weight: 600;
}
</style>
